"use strict";
var address_component_1 = require("./address.component");
exports.AddressComponent = address_component_1.AddressComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/address/index.js